import { EPermissoes } from '@/enums/ePermissoes';

export default [
  {
    description: 'Centro de Custo',
    path: 'centro-custo',
    name: 'centro-custo',
    component: () => import('@/views/gestao/centro-custo/Index.vue'),
    goesToMenu: true,
    meta: {
      permissions: [EPermissoes.CadastrosBase],
      grupos: [],
      escopoObra: 'global'
    }
  },
  {
    description: 'Inclusao de Centro de Custo',
    path: 'centro-custo/incluir',
    parent: 'centro-custo',
    name: 'centro-custo-insert',
    component: () => import('@/views/gestao/centro-custo/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'centro-custo',
      permissions: [EPermissoes.CadastrosBase],
      grupos: []
    }
  },
  {
    description: 'Edicao de Centro de Custo',
    path: 'centro-custo/editar/:id',
    parent: 'centro-custo',
    name: 'centro-custo-update',
    component: () => import('@/views/gestao/centro-custo/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'centro-custo',
      permissions: [EPermissoes.CadastrosBase],
      grupos: []
    }
  }
];
